import { createSlice } from '@reduxjs/toolkit'
import { BookingHistoryState } from './types'
import { format, startOfMonth } from 'date-fns'
import { STOP_SALES_DATE_FORMAT } from 'constants/date'

const initialState: BookingHistoryState = {
  selectedBookingHistoryRange: {
    from: format(startOfMonth(new Date()), STOP_SALES_DATE_FORMAT),
    to: format(new Date(), STOP_SALES_DATE_FORMAT),
  },
}

export const bookingHistorySlice = createSlice({
  name: 'bookingHistory',
  initialState,
  reducers: {
    setSelectedBookingHistoryRange(state, action) {
      state.selectedBookingHistoryRange = action.payload
    },
  },
})

export const bookingHistoryReducer = bookingHistorySlice.reducer
export const { setSelectedBookingHistoryRange } = bookingHistorySlice.actions
